import * as Yup from 'yup';

import { entityNameValidator } from '@zen/Accounts/validations';

export const locationDetailsValidation = Yup.object({
  accountId: Yup.string().nullable(),
  name: entityNameValidator('Location name')
});
